import { getTvObject } from '@costar-ui/cosmos';

var tvObject = getTvObject({
  base: 'h-fit rounded-sm',
  variants: {
    orientation: {
      horizontal: ['[&>*:first-child]:rounded-l-sm [&>*:last-child]:rounded-r-sm'],
      vertical: ['[&>*:first-child]:rounded-t-sm [&>*:last-child]:rounded-b-sm']
    },
    enableBorder: {
      "true": ['border border-action-neutral']
    }
  }
});
var baseToggleButtonGroup = tvObject;

export { baseToggleButtonGroup as default };
//# sourceMappingURL=base-toggle-button-group.esm.js.map
